<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :apiUrl="apiUrl"
      modalSize="lg"
      withoutDelete>

      <template #additionalButton="scope">
<!-- 
        <div class="row">
          <div class="col">
            <div class="form-row">
              <label class="col-auto col-form-label">Pendidikan :</label>
              <div class="col">
                <v-select
                  multiple
                  v-model="scopedFilterData.educationsId"
                  :options="listEducations"
                  :reduce="item => item.ID"
                  placeholder="Pilih pendidikan"
                  @input="onRefresh"
                  label="Name" />
              </div>
            </div>
          </div>

          <div class="col"></div>
        </div>
 -->
      </template>

    </AppToolbox>

    <AppTable
      :apiUrl="apiUrl"
      :fields="tableFields"
      :filter="scopedFilterData"
      :search="search"
      @onSelectItem="selectedItem = $event"
      @onDblClicked="item => openDetail(item)" />

  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.loadOptionData()
  },
  data() {
    return {
      apiUrl: '/employee-bank-account',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'Name', label: 'Nama' },
        { key: 'BankAccountName', label: 'Bank' },
        { key: 'Number', label: 'Nomer' }
      ],
      selectedItem: null,
      search: '',
      listEducations: [],
      scopedFilterData: {
        educationsId: []
      },
      educationHistoryData: [],
      selectedEmployeeId: null,
      selectedEmployeeName: ''
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    onChangeType () {
      this.onRefresh()
    },
    openDetail (item) {
      // this.assignmentHistoryData = (item.constructor === Object) ? item : this.selectedItem

      // this.$router.push(`/employee/education-history/${item.ID}`)
    },
    loadOptionData () {
      this.$axios.get('/education').then((res) => {
        this.listEducations = res.data
      })
    }
  }
}
</script>
